import React, { useEffect, useState } from "react"
import useStyles from 'isomorphic-style-loader/useStyles'
import classes from "./style.module.scss"

import { BlackMask } from "../../../../components/mask"
import BottomToTop from "../../../../components/transitions/bottom-to-top"
import ProductSizeModule from "../../module/size/product-size-module"
import AddToCartBtn from "../../module/addtocartbtn"
import { useIntl } from "react-intl"
import QuickCheckoutModal from "../../../shoppingcart/pages/quick-checkout-modal";
import {
    action_buy_now_checkout,
    action_cart_checkout,
    action_cart_checkout_get,
} from "../../../../../store/actions/pages/cart";
import {useDispatch} from "react-redux";

export const ProductAddToCartModal = (props) => {
    const { showModal, productHooks, onClose } = props
    
    const intl = useIntl();

    const {
        selectedProduct,
        selectedVariant,
        productAddToCart,
        selectVariant,
        carting
    } = productHooks

    const addToCartHandle = async () => {
        if(!selectedVariant){
            alert(intl.formatMessage({id:'please_select_size', defaultMessage:'Please Select a Size'}));
            return
        }
        await productAddToCart()
        onClose()
    } 

    useEffect(() => {
        console.log('l')
    }, [])


    return (
        <React.Fragment>
            <BottomToTop in={showModal} className={classes.AddToCartModal}>
                <div>
                    <div className={classes.Bd}>
                        <div className={classes.SizeModule}>
                            <ProductSizeModule 
                                isDetail={false} 
                                selectedProduct={selectedProduct} 
                                selectedVariant={selectedVariant} 
                                selectVariant={selectVariant} />
                        </div>
                    </div>

                    <div className={classes.Fd}>
                        <AddToCartBtn 
                            onAddCart={addToCartHandle} 
                            isDetail={false} 
                            selectedProduct={selectedProduct} 
                            selectedVariant={selectedVariant} 
                            loading={carting} />
                    </div>
                </div>
            </BottomToTop>

            {
                showModal && <BlackMask onClick={onClose} />
            }

        </React.Fragment>
    )
}

const ProductAddtocartContainer = props => {
    useStyles(classes)
    const { productHooks, babiesLookShow, showAddToCartModal: showModal, setShowAddToCartModal:setShowModal, estimatedPrice, showBtnEstimatedPrice } = props
    const {
        selectedProduct,
        selectedVariant,
        productAddToCart,
        carting,
        productVO,
        selectedVariants,
        emptySelectVariants,
    } = productHooks
    const dispatch = useDispatch()
    // const [showModal, setShowModal] = useState(false)
    const [showQuickCheckoutModal, setShowQuickCheckoutModal] = useState(false)
    const addToCartHandle = async () => {
        if(!selectedVariant){
            setShowModal(true)
            return
        }
        await productAddToCart()
        setShowModal(false)
    }
    const quickBuyBtnHandle = async () => {
        console.log("@click quickBuyBtnHandle")
        await dispatch(action_buy_now_checkout({"variantId":selectedVariant?selectedVariant.id:null,qty:selectedVariant?1:0}))
        await dispatch(action_cart_checkout_get(true))
        setShowQuickCheckoutModal(true)
    }

    return (
        <React.Fragment>

            <AddToCartBtn
                bottomBanner={props.bottomBanner}
                isDetail={true}
                onAddCart={addToCartHandle}
                selectedProduct={selectedProduct}
                selectedVariant={selectedVariant}
                loading={carting}
                isBeautyNotAddCart={productVO?.isLogisticsInCountryIsNotSupported}
                selectedVariants={selectedVariants}
                emptySelectVariants={emptySelectVariants}
                rollingMessages={productVO?.rollingMessages}
                babiesLookShow={babiesLookShow}
                estimatedPrice={estimatedPrice}
                showBtnEstimatedPrice={showBtnEstimatedPrice}
                onQuickBuy={quickBuyBtnHandle}
            />

            <ProductAddToCartModal
                showModal={showModal}
                onClose={() => setShowModal(false)}
                isBeautyNotAddCart={productVO?.isLogisticsInCountryIsNotSupported}
                productHooks={productHooks}
            />
            <QuickCheckoutModal showModal={showQuickCheckoutModal} selectedProduct={selectedProduct} selectedVariant={selectedVariant}
                                onClose={() => setShowQuickCheckoutModal(false)}/>
        </React.Fragment>

    )
}


export default ProductAddtocartContainer;